<app-touareg-control-state-layout
  [showActions]="true"
  [showSearch]="true"
  [centralButton]="state.algorithm_mode === 'Manual'"
  (onSuggestion)="onSuggestion($event)"
  (onSelection)="onSelection($event)"
  (deSelection)="deSelection($event)"
  (onManualAdd)="onManualAdd($event)"
>
  <div slot-middle class="w-100 d-flex h-100">
    <button
      [disabled]="modeFetching"
      (click)="onAccept()"
      class="btn-default btn-green col-12 h-100"
    >
      <div class="d-flex align-items-center justify-content-center">
        <span *ngIf="modeFetching" class="mr-1"
          ><mat-spinner diameter="15"></mat-spinner
        ></span>
        <span class="accept-btn">Accept</span>
      </div>
    </button>
  </div>
</app-touareg-control-state-layout>
